import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'User'*/ 'src/controllers/User/User'),
	loading: Loading,
});
